import React from 'react';
import { Box, Grid, Typography } from '@mui/material';
import { SmallCard } from '../../components/SmallCard';
import TLPAppConfig from './TLPAppConfig';

const TLPHomePage = (props) => {
    return (
        <>
            <div style={{ position: 'relative', width: '100%', height: '35vh' }}>
                <img src="/resources/amg_gt.jpg" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                <div style={{ position: 'absolute', top: '20%', left: '8%', textAlign: 'left', color: '#FFFFFF' }}>
                    <Typography variant={'h1'}>Transportation Logistics <br /> Portal (TLP)</Typography>
                </div>
            </div>

            <Box sx={{ p: 5 }}>
                {TLPAppConfig.map((category, index) => (
                    <div key={index} style={{ marginTop: 50 }}>
                        <Typography variant={'h3'}>{category.headline}</Typography>
                        <Grid container spacing={2} style={{ marginTop: 5 }}>
                            {category.subcategories.map((subcategory, subIndex) => (
                                <Grid item key={subIndex} >
                                    <SmallCard
                                        key={subIndex}
                                        outlined={subcategory.outlined}
                                        header={subcategory.name}
                                        to={subcategory.url}
                                    />
                                </Grid>
                            ))}
                        </Grid>
                    </div>
                ))}
            </Box>
        </>
    );
};

TLPHomePage.propTypes = {};

TLPHomePage.defaultProps = {};

export { TLPHomePage };
